<template>
    <div>
        <sys-pop-over-config-base 
            :model="model" 
            :configs="configs" 
            :errors="errors"
            title="Validação da Atribuição"
            tool-tip="Validação da Atribuição"
            ref="configBase"
            @menu-change="handleMenuChange"
        >
            <template v-slot:toolbar>
                <emc-button-icon 
                    icon="mdi-content-save"
                    text="Salvar e fechar"
                    @click="clickSave()" 
                />
            </template>

        </sys-pop-over-config-base>
    </div>
</template>

<script>

export default {
    name: "SysGeneralAttributionConfig",
    data: () => ({
        model: {},
        syncingModel: false,
        error: false,
        message: null,
        errors: {},
        loadingSaving: false,
        loading: false,
        configs: [
            { 
                type: 'boolean',   
                field: 'not_validate_campus_teacher',                            
                label: 'Não validar campus do professor',               
                textHelper: "Desconsiderar campus do professor no momento da atribução",
                sm: 12
            },
            { 
                type: 'boolean',   
                field: 'validate_time_table_attribution',                            
                label: 'Validar horário da atribuição',               
                textHelper: "Validar choque de horário do professor ao realizar a atribuição",
                sm: 12
            }
            
        ]
    }),
    props: {
        value: {
            type: Object,
            default: () => ({})
        }
    },
    mounted(){
        this.syncModel(this.value)
    },
    computed: {
       
    },
    watch: {
        value: {
            deep: true,
            handler(newValue){
                const nextValue = this.cloneValue(newValue)

                if (this.isSameModel(this.model, nextValue)) {
                    return
                }

                this.syncModel(nextValue)
            }
        },
        model: {
            deep: true,
            handler(newValue){
                if (this.syncingModel) {
                    return
                }
            }
        }
    },
    methods: {

        cloneValue(value){
            return { ...(value || {}) }
        },

        isSameModel(currentValue, nextValue){
            return JSON.stringify(currentValue || {}) === JSON.stringify(nextValue || {})
        },

        syncModel(value){
            this.syncingModel = true
            this.model = this.cloneValue(value)

            this.$nextTick(() => {
                this.syncingModel = false
            })
        },

        handleMenuChange(isOpen){
            if (isOpen) {
                this.syncModel(this.value)
            }
        },

        clickSave(){
            this.$refs.configBase.closeMenu();

            this.$nextTick(() => {
                this.$emit('onSave', { ...this.model });
            })

        },
        
        
    }
}
</script>
